import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
 setCurrentUnit, setPromotionSlug, setToken, setUser,
} from '../model/configuratorSlice';
import { EndPoints } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import UserService from './UserService';

export default function LoginService() {
  const { promotionSlug, promotionCode, currentUnit } = useSelector(state => state.configurator);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return useMutation(['loginQuery'], (payload) => {
    const loginConfigurationUrl = `${EndPoints.LoginUrl}/${payload.promotion_code}/${payload.unit_code}`;
    const data = {
      token: payload.token,
    };

    axios
      .post(loginConfigurationUrl, data)
      .then((response) => {
        dispatch(setToken(payload.token));
        dispatch(setPromotionSlug(response.data.promotion_slug));
        dispatch(setUser(response.data.user));
        navigate(`/${response.data.promotion_slug}`);
      })
      .catch((error) => {
        dispatch(setCurrentUnit(null));
        console.log(error);
      });
  });
}
